var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_922_23993)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_23993)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_922_23993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3594 26H14.6406C13.7361 26 13 25.2824 13 24.4C13 24.1144 13.0785 23.8331 13.2275 23.5872L18.5869 14.7867C18.8808 14.3016 19.4225 14 20 14C20.5775 14 21.1192 14.3016 21.4131 14.7867L26.7725 23.5867V23.5872C26.9215 23.8333 27 24.1144 27 24.4C27 25.2824 26.2639 26 25.3594 26Z",
    fill: "url(#paint1_linear_922_23993)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.4C19.5475 22.4 19.1797 22.7589 19.1797 23.2C19.1797 23.6411 19.5475 24 20 24C20.4525 24 20.8203 23.6411 20.8203 23.2C20.8203 22.7589 20.4525 22.4 20 22.4ZM19.5931 20.8496C19.6188 21.0496 19.7933 21.2 20 21.2C20.2067 21.2 20.3814 21.0496 20.4069 20.8496L20.817 17.6496C20.8315 17.536 20.7954 17.4211 20.7178 17.3352C20.6401 17.2493 20.528 17.2 20.4102 17.2H19.5898C19.472 17.2 19.3599 17.2493 19.2822 17.3352C19.2046 17.4211 19.1685 17.536 19.183 17.6496L19.5931 20.8496Z",
    fill: "#9867E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_922_23993",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_922_23993",
    x1: 20,
    y1: 26,
    x2: 20,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2A7EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_23993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_922_23993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.85a01d5d72d1e024e2a29eac31f10a6a.svg";
export { ForwardRef as ReactComponent };